<style>
.div-row {
  display: flex;
  justify-content: space-between; /* Distribuye los elementos con espacio entre ellos */
}
.div-searchadvance {
  font-weight: bold;
  cursor: pointer;
}
.span-right {
  text-align: right; /* Alinea el texto a la derecha dentro del span */
}
.div-total {
  font-weight: bold;
  font-size: 18px;
  color: black;
  border-bottom: 1px solid #d6d4d4;
}
.div-header {
  font-weight: bold;
  font-size: 16px;
  color: black;
  border-bottom: 1px solid #d6d4d4;
  margin-left: 30px;
}
.div-count {
  font-weight: bold;
  font-size: 14px;
  color: gray;
  border-bottom: 1px solid #d6d4d4;
  cursor: pointer;
  margin-left: 60px;
}
.div-card {
  font-weight: bold;
  font-size: 14px;
  color: gray;
  border-bottom: 1px solid #d6d4d4;
  cursor: pointer;
  margin-left: 90px;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <!-- <b-card-header header-tag="header" class="p-1" role="tab">Reporte diario de operaciones</b-card-header> -->
      <b-card-body>
        <div v-if="Show.SearchAdvance" style="margin-left:280px">
          <div
            v-if="ShowSearch.Today == false"
            style="font-weight:bold; margin-bottom:20px"
          >No incluye las operaciones del día de hoy</div>
          <div class="col-md-4" v-if="ShowSearch.AdvancedSearch">
            <label>Fecha Desde</label>
            <br />
            <KitsDate v-model="Model.FechaDesde" :currentValue="Model.FechaDesde" />
          </div>

          <div class="col-md-4" v-if="ShowSearch.AdvancedSearch">
            <label>Fecha Hasta</label>
            <br />
            <KitsDate v-model="Model.FechaHasta" :currentValue="Model.FechaHasta" />
          </div>

          <div class="col-md-4" v-if="ShowSearch.PreviousMonths">
            <label>Año</label>
            <br />
            <KitsCombo v-model="Year" v-bind:items="Years" propertyName="Value" propertyID="Value"></KitsCombo>
          </div>

          <div class="col-md-4" v-if="ShowSearch.PreviousMonths">
            <label>Mes</label>
            <br />
            <KitsCombo
              v-model="Month"
              v-bind:items="Months"
              propertyName="Name"
              propertyID="EntityID"
            ></KitsCombo>
          </div>

          <div class="col-md-4">
            <label>Sucursal</label>
            <br />
            <KitsCombo
              v-model="Model.Sucursal"
              v-bind:items="Sucursales"
              propertyName="Name"
              propertyID="EntityID"
              :todos="true"
            ></KitsCombo>
          </div>

          <div v-if="IsCashier == false" class="col-md-4">
            <label>Cajero</label>
            <br />
            <KitsCombo
              v-model="Model.Cajero"
              v-bind:items="Cajeros"
              propertyName="Name"
              propertyID="CashierID"
              :todos="true"
              :disabled="isAllSucursalSelected()"
            ></KitsCombo>
          </div>
        </div>

        <div v-if="Show.SearchAdvance" style="margin-left:270px;margin-top: 40px">
          <div class="col-md-12 text-left">
            <b-button class="btn btn-danger" @click="goBack()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>

            <b-button class="btn btn-success" @click="btnExportClick()">Descargar</b-button>
            <b-button class="btn btn-success" @click="btnClickFind()">buscar</b-button>
          </div>
        </div>

        <div v-if="this.Show.Report">
          <div
            class="text-center"
            style="font-weight: bold; font-size: 16px; margin-bottom: 40px;"
          >{{Titulo}}</div>
          <div style="margin-left: 100px;">Sucursal: {{SucusalName}}</div>
          <div style="margin-left: 100px;">Cajero: {{CajeroName}}</div>
          <div class="col-md-8" style="margin-left:100px">
            <div class="div-row div-total">
              <span>Total</span>
              <span class="span-right">$ {{Header.TotalAmount}}</span>
            </div>

            <div class="div-row div-header">
              <span>Transferencias entrantes</span>
              <span class="span-right">$ {{Header.CVUTransferencesAmount}}</span>
            </div>
            <div class="div-row div-count">
              <span>Cantidad de operaciones: {{Header.CVUTransferencesCount}}</span>
            </div>

            <div>
              <div class="div-row div-header">
                <span>Cobro con QR</span>
                <span class="span-right">$ {{Header.QRsAmount}}</span>
              </div>
              <div class="div-row div-count">
                <span>Cantidad de operaciones: {{Header.QRsCount}}</span>
              </div>
              <div class="div-row div-header">
                <span>Devoluciones QR</span>
                <span>$ {{Header.QRsDevolutionsAmount}}</span>
              </div>
              <div class="div-row div-count">
                <span>Cantidad de operaciones: {{Header.QRsDevolutionsCount}}</span>
              </div>
            </div>

            <div>
              <div class="div-row div-header">
                <span>Cobro con Tarjeta - Débito</span>
                <span class="span-right">$ {{Header.DebitPaymentAmount}}</span>
              </div>
              <div class="div-row div-count" @click="ShowDebitDetailList = !ShowDebitDetailList">
                <span>Cantidad de operaciones: {{Header.DebitPaymentCount}}</span>
                <span v-if="Header.DebitPaymentCount > 0" class="span-right">Ver Detalle ></span>
              </div>
              <div v-if="ShowDebitDetailList">
                <div
                  class="div-row div-card"
                  v-for="itemDetail in this.DebitDetailList"
                  v-bind:key="itemDetail.EntityID"
                  @click="ShowDebitDetailList = !ShowDebitDetailList"
                >
                  <span>{{itemDetail.PaymentCardName}}: {{itemDetail.PaymentCount}}</span>
                  <span class="span-right">${{itemDetail.PaymentAmount}}</span>
                </div>
              </div>
              <div class="div-row div-header">
                <span>Devoluciones Débito</span>
                <span>$ {{Header.DebitPaymentDevolutionsAmount}}</span>
              </div>
              <div class="div-row div-count">
                <span>Cantidad de operaciones: {{Header.DebitPaymentDevolutionsCount}}</span>
              </div>
            </div>

            <div>
              <div class="div-row div-header">
                <span>Cobro con Tarjeta - Crédito</span>
                <span>$ {{Header.CreditPaymentAmount}}</span>
              </div>
              <div class="div-row div-count" @click="ShowCreditDetailList = !ShowCreditDetailList">
                <span>Cantidad de operaciones: {{Header.CreditPaymentCount}}</span>
                <span v-if="Header.CreditPaymentCount > 0" class="span-right">Ver Detalle ></span>
              </div>
              <div v-if="ShowCreditDetailList">
                <div
                  class="div-row div-card"
                  v-for="itemDetail in this.CreditDetailList"
                  v-bind:key="itemDetail.EntityID"
                  @click="ShowCreditDetailList = !ShowCreditDetailList"
                >
                  <span>{{itemDetail.PaymentCardName}}: {{itemDetail.PaymentCount}}</span>
                  <span class="span-right">${{itemDetail.PaymentAmount}}</span>
                </div>
              </div>
              <div class="div-row div-header">
                <span>Devoluciones Crédito</span>
                <span>$ {{Header.CreditPaymentDevolutionsAmount}}</span>
              </div>
              <div class="div-row div-count">
                <span>Cantidad de operaciones: {{Header.CreditPaymentDevolutionsCount}}</span>
              </div>
            </div>

            <div class="col-md-12 text-left" style="margin-top: 20px">
              <b-button class="btn btn-danger" @click="goBack()">
                <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
              </b-button>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import store from "@/store";
import axiosHelpers from "@/helpers/axiosHelpers";
import DateTime from "luxon/src/datetime.js";
import KitsDate from "@/components/KitsDate";
import KitsCombo from "@/components/KitsCombo";
import datetimeHelpers from "@/helpers/datetimeHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import fileHelpers from "@/helpers/fileHelpers";

export default {
  components: { KitsDate, KitsCombo },
  props: {
    SearchIDProp: Number
  },
  data() {
    return {
      SearchID: this.SearchIDProp,
      IsCashier: false,
      Model: {
        FechaDesde: null,
        FechaHasta: null,
        Sucursal: null,
        Cajero: null
      },
      Sucursales: [],
      CajerosFullList: [],
      Cajeros: [],
      Years: [],
      Months: [],
      AllMonths: [],
      CurrentYearMonths: [],
      Year: null,
      Month: null,

      Show: {
        SearchAdvance: true,
        Report: false
      },

      ShowSearch: {
        Today: false,
        ActualMonth: false,
        PreviousMonths: false,
        AdvancedSearch: false
      },

      Titulo: "",
      SucusalName: "Todos",
      CajeroName: "Todos",

      Header: [],
      DebitDetailList: [],
      CreditDetailList: [],
      ShowDebitDetailList: false,
      ShowCreditDetailList: false
    };
  },
  methods: {
    getCashiersByBranchOffice() {
      let context = this;
      context.Cajeros = [];
      context.CajerosFullList.forEach(x => {
        if (x.BranchOfficeID == context.Model.Sucursal) {
          var Cajero = {
            CashierID: x.EntityID,
            Name: x.Name
          };
          context.Cajeros.push(Cajero);
        }
      });
    },
    sucursalChanged() {
      let context = this;
      if (context.Model.Sucursal != null && !isNaN(context.Model.Sucursal)) {
        context.getCashiersByBranchOffice();
      } else {
        context.Model.Cajero = null;
      }

      context.setNames();
    },
    isAllSucursalSelected() {
      let context = this;
      if (
        context.Model.Sucursal == null ||
        isNaN(context.Model.Sucursal) ||
        context.Sucursales.length == 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    goBack() {
      let context = this;

      context.$router.push({
        name: "ReporteOperacionesSearchDates"
      });
    },
    showSearchAdvance() {
      let context = this;

      context.Model.Sucursal = null;
      context.Model.Cajero = null;

      if (context.SearchID == 1) {
        context.SelectSearch(true, false, false, false);
      } else if (context.SearchID == 2) {
        context.SelectSearch(false, true, false, false);
      } else if (context.SearchID == 3) {
        context.SelectSearch(false, false, true, false);
      } else if (context.SearchID == 4) {
        context.SelectSearch(false, false, false, true);
      }
    },
    SelectSearch(Today, ActualMonth, PreviousMonths, AdvancedSearch) {
      let context = this;
      context.ShowSearch.Today = Today;
      context.ShowSearch.ActualMonth = ActualMonth;
      context.ShowSearch.PreviousMonths = PreviousMonths;
      context.ShowSearch.AdvancedSearch = AdvancedSearch;
    },
    btnExportClick() {
      let context = this;

      if (context.ShowSearch.Today) {
        context.GetActualDateDailyOperationsReportViewer(true);
      } else {
        context.GetDailyOperationsReportForReport(true);
      }
    },
    setNames() {
      let context = this;

      if (context.Model.Sucursal != null && !isNaN(context.Model.Sucursal)) {
        context.SucusalName = context.Sucursales.find(
          x => x.EntityID == context.Model.Sucursal
        ).Name;
      } else {
        context.SucusalName = "Todos";
      }

      if (context.Model.Cajero != null && !isNaN(context.Model.Cajero)) {
        context.CajeroName = context.Cajeros.find(
          x => x.CashierID == context.Model.Cajero
        ).Name;
      } else {
        context.CajeroName = "Todos";
      }
    },
    btnClickFind() {
      let context = this;

      if (context.ShowSearch.Today) {
        context.GetActualDateDailyOperationsReportViewer(false);
      } else {
        context.GetDailyOperationsReportForReport(false);
      }
    },
    InitializeSearchDates() {
      let context = this;

      axiosHelpers.axiosGet(
        "DailyOperationsReport/GetOperationsReportViewerIndex",
        {},
        context,
        function(data) {
          context.Sucursales = data.ResponseVM.BranchOffices;
          context.CajerosFullList = data.ResponseVM.Cashiers;
          context.Cajeros = [];

          context.Years = data.ResponseVM.YearItems;
          context.AllMonths = data.ResponseVM.MonthItems;
          context.Months = data.ResponseVM.MonthItems;

          context.InitilizeCurrentYearMonths(context);

          context.Year = DateTime.local().year;

          var NroMesAnterior = DateTime.local().month - 2;
          context.Month = context.Months[NroMesAnterior].EntityID;

          context.showSearchAdvance();
        }
      );
    },
    InitilizeCurrentYearMonths(context) {
      var ActualMonth = DateTime.local().month;
      context.Months.forEach(x => {
        if (x.EntityID < ActualMonth) {
          context.CurrentYearMonths.push(x);
        }
      });
    },
    SetMonthsCombo(NewYearValue) {
      let context = this;
      if (DateTime.local().year == NewYearValue) {
        context.Months = context.CurrentYearMonths;
      } else {
        context.Months = context.AllMonths;
      }
    },
    GetActualDateDailyOperationsReportViewer(IsExport) {
      let context = this;

      context.Titulo =
        "Reporte de operaciones al " +
        datetimeHelpers.getToday().substring(0, 10);

      axiosHelpers.axiosGet(
        "DailyOperationsReport/GetActualDateDailyOperationsReportViewer",
        {
          BranchOfficeID: context.Model.Sucursal,
          CashierID: context.Model.Cajero,

          IsExport: IsExport,
          Title: context.Titulo,
          BranchOfficeName: context.SucusalName,
          CashierName: context.CajeroName
        },
        context,
        function(data) {
          if (data.Alerts.length == 0) {
            if (IsExport == false) {
              context.Header = data.ResponseVM.Header;
              context.DebitDetailList = [];
              context.CreditDetailList = [];

              data.ResponseVM.Header.DetaiList.forEach(x => {
                if (
                  x.PaymentMethodID ==
                  context.$store.getters.ID_CREDIT_PAYMENT_METHOD
                ) {
                  context.CreditDetailList.push(x);
                } else {
                  context.DebitDetailList.push(x);
                }
              });

              context.Show.SearchAdvance = false;
              context.Show.Report = true;
            } else {
              if (data.ResponseVM.Export.HasErrors == false) {
                var contentType =
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                fileHelpers.downloadFile(
                  context,
                  data.ResponseVM.Export.FileContent,
                  data.ResponseVM.Export.FileName,
                  contentType
                );
              }
            }
          }
        }
      );
    },
    GetDailyOperationsReportForReport(IsExport) {
      let context = this;

      var req = {
        DateFrom: null,
        DateTo: null,
        BranchOfficeID: context.Model.Sucursal,
        CashierID: context.Model.Cajero,

        IsExport: IsExport,
        BranchOfficeName: context.SucusalName,
        CashierName: context.CajeroName
      };

      // -- Busqueda Mes Actual
      if (context.ShowSearch.ActualMonth) {
        var dt = DateTime.local();
        var hasta = DateTime.local(dt.year, dt.month, dt.day, 0, 0)
          .plus({ days: -1 })
          .toString()
          .substring(0, 10);

        context.Titulo =
          "Reporte de operaciones desde " +
          datetimeHelpers.getMonthStart().substring(0, 10) +
          " 00:00:00 hasta " +
          hasta +
          " 23:59:59";

        req.DateFrom = datetimeHelpers.getMonthStart().substring(0, 10);
        req.DateTo = datetimeHelpers.getToday().substring(0, 10);
      }
      // -- Busqueda Meses Anteriores
      else if (context.ShowSearch.PreviousMonths) {
        context.Titulo =
          "Reporte de operaciones al " + context.Month + "-" + context.Year;

        var fechaDesde = DateTime.local(context.Year, context.Month, 1, 0, 0);
        var fechaHasta = fechaDesde.plus({ months: 1 });

        req.DateFrom = fechaDesde.toString().substring(0, 10);
        req.DateTo = fechaHasta.toString().substring(0, 10);
      }
      // -- Busqueda Avanzada
      else if (context.ShowSearch.AdvancedSearch) {
        if (context.Model.FechaDesde == "") {
          notificationHelpers.showWarning(
            "Advertencia!",
            "Debe seleccionar una fecha desde",
            context
          );
          context.Show.SearchAdvance = true;
          return;
        }

        if (context.Model.FechaHasta == "") {
          notificationHelpers.showWarning(
            "Advertencia!",
            "Debe seleccionar una fecha hasta",
            context
          );
          context.Show.SearchAdvance = true;
          return;
        }

        if (
          datetimeHelpers.compareFromTo(
            context.Model.FechaDesde,
            context.Model.FechaHasta
          )
        ) {
          notificationHelpers.showWarning(
            "Advertencia!",
            "La fecha desde debe ser anterior a la fecha hasta",
            context
          );
          context.Show.SearchAdvance = true;
          return;
        }

        var fechaHoraActual = DateTime.local();
        var fechaActual = DateTime.local(
          fechaHoraActual.year,
          fechaHoraActual.month,
          fechaHoraActual.day,
          0,
          0
        );

        if (context.Model.FechaDesde == context.Model.FechaHasta) {
          notificationHelpers.showWarning(
            "Advertencia!",
            "La fecha desde debe ser anterior a la fecha hasta",
            context
          );
          context.Show.SearchAdvance = true;
          return;
        }

        var DateTo = new Date(context.Model.FechaHasta.substring(0, 10));
        DateTo.setDate(DateTo.getDate());
        if (DateTo >= fechaActual) {
          notificationHelpers.showWarning(
            "Advertencia!",
            "Solo se pueden filtrar las operaciones previas al día de hoy",
            context
          );
          context.Show.SearchAdvance = true;
          return;
        }

        var cantidadDiasBusquedaAvanzada = 31;
        if (
          datetimeHelpers.compareDifference(
            context.Model.FechaDesde,
            context.Model.FechaHasta,
            cantidadDiasBusquedaAvanzada
          )
        ) {
          notificationHelpers.showWarning(
            "Advertencia!",
            "El rango de fechas ingresado no puede superar los " +
              cantidadDiasBusquedaAvanzada +
              " días",
            context
          );
          context.Show.SearchAdvance = true;
          return;
        }

        var DateFrom = context.Model.FechaDesde.substring(0, 10);
        var DateTo = context.Model.FechaHasta.substring(0, 10);

        req.DateFrom = DateFrom;
        req.DateTo = DateTo;

        var DateToFormatted = new Date(DateTo.substring(0, 10));
        DateToFormatted.setDate(DateToFormatted.getDate());

        context.Titulo =
          "Reporte de operaciones desde " +
          DateFrom +
          " 00:00:00 hasta " +
          datetimeHelpers.getFormattedYYYYMMDD(DateToFormatted) +
          " 23:59:59";
      }

      req.Title = context.Titulo;

      axiosHelpers.axiosGet(
        "DailyOperationsReport/GetDailyOperationsReportForReport",
        req,
        context,
        function(data) {
          if (data.Alerts.length == 0) {
            if (IsExport == false) {
              context.Header = data.ResponseVM.Header;
              context.DebitDetailList = [];
              context.CreditDetailList = [];

              data.ResponseVM.Header.DetaiList.forEach(x => {
                if (
                  x.PaymentMethodID ==
                  context.$store.getters.ID_CREDIT_PAYMENT_METHOD
                ) {
                  context.CreditDetailList.push(x);
                } else {
                  context.DebitDetailList.push(x);
                }
              });

              context.Show.SearchAdvance = false;
              context.Show.Report = true;
            } else {
              if (data.ResponseVM.Export.HasErrors == false) {
                var contentType =
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                fileHelpers.downloadFile(
                  context,
                  data.ResponseVM.Export.FileContent,
                  data.ResponseVM.Export.FileName,
                  contentType
                );
              }
            }
          }
        }
      );
    }
  },
  beforeMount() {
    var context = this;
    context.IsCashier = store.getters.isCashier;
    this.InitializeSearchDates();
  },
  watch: {
    "Model.Sucursal": function(newValue, oldValue) {
      if (this.IsCashier == false) {
        this.sucursalChanged();
      }
    },
    "Model.Cajero": function(newValue, oldValue) {
      this.setNames();
    },
    Year: function(newValue, oldValue) {
      this.SetMonthsCombo(newValue);
    }
  }
};
</script>